import React from 'react';
import Type from 'prop-types';
import { Typography } from "@mui/material";
import { useTranslation } from 'hooks';
import { formatNumber } from '../../utils/formatters';

const FormattedNumber = ({ value, options, ...other }) => {
  const { locale } = useTranslation();
  const formattedValue = formatNumber(value, locale, options);

  return <Typography {...other}>{formattedValue}</Typography>;
};

FormattedNumber.propTypes = {
  value: Type.number.isRequired,
  options: Type.shape({
    currency: Type.string,
    style: Type.oneOf(['decimal', 'percent', 'currency', 'unit']),
    localeMatcher: Type.oneOf(['best fit', 'lookup']),
    numberingSystem: Type.string,
    unit: Type.string,
    unitDisplay: Type.oneOf(['short', 'narrow', 'long']),
    compactDisplay: Type.oneOf(['short', 'long']),
    currencyDisplay: Type.oneOf(['code', 'symbol', 'narrowSymbol', 'name']),
    useGrouping: Type.bool,
    minimumIntegerDigits: Type.number,
    minimumFractionDigits: Type.number,
    maximumFractionDigits: Type.number,
    minimumSignificantDigits: Type.number,
    maximumSignificantDigits: Type.number,
    notation: Type.oneOf(['standard', 'scientific', 'engineering', 'compact']),
  }),
  color: Type.string,
  component: Type.node,
  variant: Type.string,
  align: Type.string,
};

FormattedNumber.defaultProps = {
  color: 'textPrimary',
  align: 'inherit',
  component: 'span',
  variant: 'body2',
  options: null,
};

export default FormattedNumber;
